export default function initReadmoreToggle() {
    const readmoreToggle = document.querySelectorAll('.js-wrapper-readmore');
    
    readmoreToggle.forEach((container: Element) => {
        new ReadmoreToggle(container);
    });
}

class ReadmoreToggle {
    private $el: Element;
    private $buttonToggle: HTMLButtonElement | null;

    constructor($el: Element) {
        this.$el = $el;
        this.$buttonToggle = this.$el.querySelector('.js-btn-readmore-toggle');

        this.$buttonToggle?.addEventListener('click', ()=> {
            this.$el.classList.toggle('open');
        });
    }
}


